// @flow
import { GET_ALL_WORKOUTS } from './actionTypes'

export default ({ pagination, filterGroup }) => ({
  type: GET_ALL_WORKOUTS,
  payload: {
    pagination,
    filterGroup, // filters, favorites, unFiltered
  }
})